import type { MaybeRefOrGetter } from "vue";
import type { SeoImage } from "@/utils/seoImage";

// Une source nulle n'émet aucune balise : l'image par défaut posée dans `app.vue` reste en place.
export function useSeoImage(source: MaybeRefOrGetter<SeoImage | null | undefined>) {
  const image = computed(() => toValue(source));

  useSeoMeta({
    ogImage: () => image.value?.url,
    ogImageAlt: () => image.value?.alt,
    ogImageWidth: () => image.value?.width,
    ogImageHeight: () => image.value?.height,
    twitterImage: () => image.value?.url,
    twitterImageAlt: () => image.value?.alt,
  });
}
